import * as React from "react";
const SvgShare = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 72 72", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, fill: "none", transform: "scale(1.3 1.3) translate(-8 -8)", stroke: "currentColor" }, /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 22, r: 5 }), /* @__PURE__ */ React.createElement("circle", { cx: 22, cy: 38, r: 5 }), /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 50, r: 5 }), /* @__PURE__ */ React.createElement("path", { d: "m27 40 18 8" }), /* @__PURE__ */ React.createElement("path", { d: "m45 25-18 10" })));
export default SvgShare;
